import React from 'react';
import { Link } from 'react-router-dom';
import { HiUserGroup, HiOfficeBuilding } from 'react-icons/hi';

/**
 * Visual tab selector shown at the top of login pages so visitors clearly
 * see both account types and pick the right one.
 */
const AuthTypeTabs = ({ active, mode = 'login' }) => {
  const communityHref = mode === 'register' ? '/register?type=community_member' : '/community-login';
  const businessHref = mode === 'register' ? '/register?type=business_owner' : '/business-login';

  const baseTab =
    'flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-xl font-semibold text-sm sm:text-base transition-all border-2';
  const activeCls = (color) =>
    color === 'primary'
      ? 'bg-primary text-white border-primary shadow-md'
      : 'bg-secondary text-white border-secondary shadow-md';
  const inactiveCls = 'bg-white text-neutral-600 border-neutral-200 hover:border-neutral-400 hover:text-neutral-900';

  return (
    <div className="mb-6" data-testid="auth-type-tabs">
      <p className="text-center text-sm text-neutral-500 mb-3">
        I am a&hellip;
      </p>
      <div className="flex gap-3">
        <Link
          to={communityHref}
          className={`${baseTab} ${active === 'community' ? activeCls('primary') : inactiveCls}`}
          data-testid="tab-community"
        >
          <HiUserGroup className="w-5 h-5" />
          Community Member
        </Link>
        <Link
          to={businessHref}
          className={`${baseTab} ${active === 'business' ? activeCls('secondary') : inactiveCls}`}
          data-testid="tab-business"
        >
          <HiOfficeBuilding className="w-5 h-5" />
          Business Owner
        </Link>
      </div>
    </div>
  );
};

export default AuthTypeTabs;
